import { ConfigProvider, Spin } from 'antd';

import { TableWrapper } from '../../../../components/index';
import { TrackingLogType } from '../../../../types';
import { ReportsTable } from '../styles';
import { ChargeReportTableColumns } from './chargeReportTableColumns';

type ChargeReportTableProps = {
  dataSource?: Array<TrackingLogType>;
  totalItems?: number;
  isLoadingChargeReportData?: boolean;
  onChangePagination: React.Dispatch<React.SetStateAction<number>>;
  queryPage?: number;
  onShowSizeChange: React.Dispatch<React.SetStateAction<number>>;
};
export function ChargeReportTable(props: ChargeReportTableProps) {
  const {
    dataSource,
    totalItems,
    isLoadingChargeReportData,
    onChangePagination,
    queryPage,
    onShowSizeChange,
  } = props;

  function customizeRenderEmpty() {
    return <>Não há dados cadastrados.</>;
  }

  return (
    <Spin spinning={isLoadingChargeReportData} tip="Carregando...">
      <TableWrapper>
        <ConfigProvider renderEmpty={customizeRenderEmpty}>
          <ReportsTable
            rowKey="key"
            pagination={{
              position: ['bottomCenter'],
              defaultPageSize: dataSource?.length,
              total: totalItems,
              showSizeChanger: true,
              onChange: (page) => onChangePagination(page),
              current: queryPage,
              onShowSizeChange: (current, size) => onShowSizeChange(size),
            }}
            columns={ChargeReportTableColumns(dataSource)}
            dataSource={dataSource}
            scroll={{ y: '60vh', scrollToFirstRowOnChange: false }}
            loading={isLoadingChargeReportData}
          />
        </ConfigProvider>
      </TableWrapper>
    </Spin>
  );
}
